<template>
  <section class="app-section"
           id="information">
    <div>
      <div class="container"
           v-show="!showEdit">
        <div class="preview">
          <img style="width:329px;height:630px;"
               src="../../images/iphone6_wechat.png">
          <div style="width:329px;height:630px;background-color:rgba(0,0,0,0);position:absolute;top:20px;left:0;"></div>
          <div class="preview-content">
            <img :src="info.photo"
                 style="width:100%;height:auto;margin-top:10px;">
            <div style="margin-top:10px;padding:8px 15px;background-color:#fff;border-bottom:solid 1px #e8e8e8;">{{info.name}}</div>
            <div style="padding:8px 15px;background-color:#fff;border-bottom:solid 1px #e8e8e8;line-height:15px;word-break:break-all;height:auto;"><i class="fa fa-trophy"
                 aria-hidden="true"></i>{{info.level}}</div>
            <div style="padding:8px 15px;background-color:#fff;border-bottom:solid 1px #e8e8e8;line-height:15px;word-break:break-all;"><i class="fa fa-phone"
                 aria-hidden="true"></i>{{info.phone}}</div>
            <div style="padding:8px 15px;background-color:#fff;border-bottom:solid 1px #e8e8e8;line-height:15px;word-break:break-all;"><i class="fa fa-desktop"
                 aria-hidden="true"
                 style="font-size:12px;"></i>{{info.url}}</div>
            <div style="padding:8px 15px;background-color:#fff;border-bottom:solid 1px #e8e8e8;line-height:15px;word-break:break-all;"><i class="fa fa-map-marker"
                 aria-hidden="true"></i>{{info.address}}</div>
            <div v-html="info.intro"
                 class="preview-intro"></div>
          </div>
        </div>
        <div class="information-content">
          <div style="text-align:center;line-height: 40px;">医院简介</div>
          <div class="information-des"
               v-html="info.intro"></div>
          <div style="text-align:center;padding-top:20px;">
            <el-button type="primary"
                       @click="showEdit = true">编辑信息</el-button>
          </div>
        </div>
      </div>
      <div class="container2"
           v-show="showEdit">
        <div class="container2-top">
          <div class="picture-upload-wrapper">
            <el-upload class="avatar-uploader"
                       :class="{'haveImg': editForm.photo}"
                       :action="fast_upload"
                       :headers="{'Authorization': $store.state.Authorization,'tenant': $store.state.tenant.tenant}"
                       :show-file-list="showFileList"
                       :on-success="handleAvatarSuccess"
                       :before-upload="beforeAvatarUpload">
              <img v-if="editForm.photo"
                   :src="editForm.photo"
                   class="avatar">
              <i v-if="!editForm.photo"
                 class="fa el-icon-camera"
                 aria-hidden="true"></i>
              <span v-if="!editForm.photo">上传的图片不要超过2M，建议上传460*270的尺寸</span>
              <div class="hover-show">
                <i class="fa el-icon-camera"
                   aria-hidden="true"></i>
                <span>上传的图片不要超过2M，建议上传460*270的尺寸</span>
              </div>
            </el-upload>
          </div>
          <div class="form-top">
            <el-form :model="editForm"
                     :rules="editRules"
                     ref="ruleForm"
                     label-width="100px"
                     class="demo-ruleForm"
                     size="medium">
              <el-form-item label="医院名称"
                            prop="name">
                <el-input v-model="editForm.name"></el-input>
              </el-form-item>
              <el-form-item label="医院等级"
                            prop="level">
                <el-input v-model="editForm.level"></el-input>
              </el-form-item>
              <el-form-item label="医院电话"
                            prop="phone">
                <el-input v-model="editForm.phone"></el-input>
              </el-form-item>
              <el-form-item label="医院网址"
                            prop="url">
                <el-input v-model="editForm.url"></el-input>
              </el-form-item>
              <el-form-item label="医院地址"
                            prop="address">
                <el-input v-model="editForm.address"></el-input>
              </el-form-item>
            </el-form>
          </div>
        </div>
        <div>
          <el-form label-position="top"
                   :model="editForm"
                   :rules="editRules"
                   ref="ruleForm"
                   label-width="80px"
                   class="demo-ruleForm">
            <el-form-item label="医院简介"
                          prop="intro">
              <div id="infoContentMenu"
                   class="w-e-toolbar"></div>
              <div id="infoContent"
                   class="infoContent"></div>
            </el-form-item>
            <el-form-item>
              <el-button type="primary"
                         @click="edit">保存</el-button>
              <el-button type="text"
                         @click="showEdit = false">取消</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <!-- <div style="height:5px"></div>
      <el-tabs v-model="activeTabName">
        <el-tab-pane label="基本信息"
                     name="first">
        
        </el-tab-pane>
        <el-tab-pane label="楼群分布"
                     name="second">
          <div style="padding-top:20px;text-align:center;">
            <el-upload class="picture-uploader"
                       :class="{'haveImg': editForm.floor_picture}"
                       :action="fast_upload"
                       :headers="{'Authorization': $store.state.Authorization}"
                       :show-file-list="showFileList"
                       :on-success="handlePictureSuccess"
                       :before-upload="beforePictureUpload">
              <img v-if="editForm.floor_picture"
                   :src="editForm.floor_picture"
                   class="picture">
              <i v-if="!editForm.floor_picture"
                 class="fa el-icon-camera"
                 aria-hidden="true"></i>
              <span v-if="!editForm.floor_picture">上传的图片不要超过2M，建议上传宽度为640px的图片</span>
              <div class="hover-show">
                <i class="fa el-icon-camera"
                   aria-hidden="true"></i>
                <span>上传的图片不要超过2M，建议上传460*270的尺寸</span>
              </div>
            </el-upload>
            <div style="padding-top:20px;">
              <el-button type="primary"
                         @click="editPic">保存</el-button>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs> -->
    </div>

  </section>
</template>

<script>
import { Loading } from 'element-ui'
import { CARINGFAST, FAST_UPLOAD, uploadImgServer } from '../../utils/env'

// import jQuery from 'jquery'
import E from 'wangeditor'

export default {
  name: 'information',
  data: function () {
    return {
      fast_upload: '',
      activeTabName: 'first',
      showFileList: true,
      editForm: {
        photo: '',
        name: '',
        level: '',
        phone: '',
        address: '',
        url: '',
        intro: '',
        floor_picture: '',
      },
      type: 'PUT',
      editRules: {
        name: [{ required: true, message: '请输入医院名称', trigger: 'blur' }],
        level: [{ required: true, message: '请输入医院等级', trigger: 'blur' }],
        phone: [{ required: true, message: '请输入医院电话', trigger: 'blur' }],
        address: [
          { required: true, message: '请输入医院地址', trigger: 'blur' },
        ],
        url: [{ required: true, message: '请输入医院网址', trigger: 'blur' }],
        intro: [{ required: true, message: '请输入医院简介', trigger: 'blur' }],
      },
      showEdit: false,
      info: {
        intro: '',
        photo: '',
        name: '',
        level: '',
        phone: '',
        address: '',
        floor_picture: '',
      },
    }
  },
  methods: {
    beforeAvatarUpload(file) {
      // console.log(file)
      let _type = file.type
      if (
        _type !== 'image/png' &&
        _type !== 'image/jpg' &&
        _type !== 'image/jpeg'
      ) {
        this.$message.error('只能上传PNG/JPG/JPEG格式的图片文件')
        return false
      }
      let _size = file.size
      if (_size > 2097152) {
        this.$message.error('图片文件大小不能超过2M')
        return false
      }
    },
    handleAvatarSuccess(res, file) {
      this.showFileList = false
      if (res.code === 0) {
        console.log(res)
        this.editForm.photo = CARINGFAST + res.data
      } else {
        this.$message.error('图片上传失败')
      }
    },
    beforePictureUpload(file) {
      // console.log(file)
      let _type = file.type
      if (
        _type !== 'image/png' &&
        _type !== 'image/jpg' &&
        _type !== 'image/jpeg'
      ) {
        this.$message.error('只能上传PNG/JPG/JPEG格式的图片文件')
        return false
      }
      let _size = file.size
      if (_size > 2097152) {
        this.$message.error('图片文件大小不能超过2M')
        return false
      }
    },
    handlePictureSuccess(res, file) {
      this.showFileList = false
      if (res.code === 0) {
        this.editForm.floor_picture = this.$store.state.fileDIR + res.data
        this.info.floor_picture = this.$store.state.fileDIR + res.data
      } else {
        this.$message.error('图片上传失败')
      }
    },
    getInitInfo() {
      // let loadingInstance = Loading.service({ fullscreen: false })
      let self = this

      this.$utils.caringRequest({
        method: 'GET',
        url: this.$utils.getInterface('HOSPITALINFO'),
        auth: true,
        success: (res) => {
          if (res.code === 0) {
            if (res.data === null) {
              self.$notify.warning({
                title: '提示',
                message: '没有相关数据，请先添加',
              })
              self.type = 'POST'
              self.showEdit = true
              return
            }
            self.info = res.data
            self.editForm = JSON.parse(JSON.stringify(res.data))
            self.editorEdit.txt.html(self.editForm.intro)
          } else {
            self.$notify.error({
              title: '错误',
              message: res.message,
            })
          }
        },
      })
    },
    editPic() {
      if (!this.editForm.floor_picture) {
        this.$message({
          showClose: true,
          message: '请上传楼层分布图',
          type: 'warning',
        })
        return
      }
      this.edit()
    },
    edit() {
      let name = this.editForm.name.replace(/\s/g, '')
      let level = this.editForm.level.replace(/\s/g, '')
      let phone = this.editForm.phone.replace(/\s/g, '')
      let address = this.editForm.address.replace(/\s/g, '')
      let url = this.editForm.url.replace(/\s/g, '')

      let intro =
        '<div style="font-size:16px;line-height:1.6" class="chinacaring-style">' +
        this.editorEdit.txt.html() +
        '</div>' // 特别注意：由于wangeditor v3没有支持line-height和font-size，所以需要自己css设置，于是我们在编辑器区域设置font-size:16px;line-height:1.6; 在获取编辑器html同时，在最外层包裹<div style="font-size:16px;line-height:1.6" class="chinacaring-style"></div>，以达到同编辑框样式一致的效果,chinacaring-style为了增加内容样式可编辑性
      let photo = this.editForm.photo
      let floorPicture = this.editForm.floor_picture
      if (!name) {
        this.$message({
          showClose: true,
          message: '请填写医院名称',
          type: 'warning',
        })
        return
      }
      if (!level) {
        this.$message({
          showClose: true,
          message: '请填写医院等级',
          type: 'warning',
        })
        return
      }
      if (!phone) {
        this.$message({
          showClose: true,
          message: '请填写医院电话',
          type: 'warning',
        })
        return
      }
      if (!address) {
        this.$message({
          showClose: true,
          message: '请填写医院地址',
          type: 'warning',
        })
        return
      }
      if (!url) {
        this.$message({
          showClose: true,
          message: '请填写医院网址',
          type: 'warning',
        })
        return
      }
      if (!intro) {
        this.$message({
          showClose: true,
          message: '请填写医院简介',
          type: 'warning',
        })
        return
      }
      if (!photo) {
        this.$message({
          showClose: true,
          message: '请上传医院图片',
          type: 'warning',
        })
        return
      }
      let loadingInstance = Loading.service({ fullscreen: false })
      let self = this
      console.log(this.editForm.photo)
      let query = {
        name: name,
        level: level,
        phone: phone,
        address: address,
        url: url,
        intro: intro,
        photo: photo,
        floor_picture: floorPicture,
      }
      if (self.type == 'PUT') {
        query.id = self.editForm.id
      }
      this.$utils.caringRequest({
        method: self.type,
        url: this.$utils.getInterface('HOSPITALINFO'),
        auth: true,
        data: query,
        success: (res) => {
          loadingInstance.close()
          if (res.code === 0) {
            self.type = 'PUT'
            self.editForm.intro = intro
            self.info = JSON.parse(JSON.stringify(self.editForm))
            self.showEdit = false
            self.$notify({
              title: '成功',
              message: '修改成功',
              type: 'success',
            })
          } else {
            self.$notify.error({
              title: '错误',
              message: 'ERROR（' + res.code + '）：' + res.message,
            })
          }
        },
      })
    },
  },
  mounted: function () {
    this.fast_upload = FAST_UPLOAD
    this.getInitInfo()
    var self = this
    var editorConfig = {
      debug: true,
      menus: [
        // 'head',  // 标题
        'bold', // 粗体
        'italic', // 斜体
        'underline', // 下划线
        // 'strikeThrough',  // 删除线
        'foreColor', // 文字颜色
        'backColor', // 背景颜色
        'link', // 插入链接
        // 'list',  // 列表
        'justify', // 对齐方式
        // 'quote',  // 引用
        // 'emoticon',  // 表情
        'image', // 插入图片
        'table', // 表格
        // 'video',  // 插入视频
        // 'code',  // 插入代码
        'undo', // 撤销
        'redo', // 重复
      ],
      pasteFilterStyle: true, // 粘贴样式的过滤
      uploadImgHeaders: {
        Authorization: self.$store.state.Authorization, // editor上传图片配置
      },
      uploadFileName: 'file',
      uploadImgMaxLength: 1, // 限制一次最多上传 1 张图片
      uploadImgServer: self.$store.state.uploadImgServer,
      uploadImgHooks: {
        customInsert: function (insertImg, result, editor) {
          // 图片上传并返回结果，自定义插入图片的事件（而不是编辑器自动插入图片！！！）
          // insertImg 是插入图片的函数，editor 是编辑器对象，result 是服务器端返回的结果
          if (result.code === 0) {
            let url = self.$store.state.fileDIR + result.data
            insertImg(url)
          } else {
            self.$message.error(result.message)
          }
        },
      },
      zIndex: 1,
      customAlert: function (info) {
        // info 是需要提示的内容
        self.$message.error(info)
      },
    }
    var editorEdit = new E('#infoContentMenu', '#infoContent')
    //     var editorEdit = new E('#deptsContentMenu', '#deptsContent')
    editorEdit.customConfig = editorConfig
    this.editorEdit = editorEdit
    this.editorEdit.create()
  },
}
</script>

<style lang="less">
#information {
  min-width: 0;
  min-height: 0;
  padding: 20px;
  padding-top: 0;
}
#information .preview-intro {
  margin-top: 10px;
  padding: 8px 15px;
  background-color: #fff;
  word-break: break-all;
}
#information .preview-intro .chinacaring-style {
  font-size: 13px !important;
}
#information .w-e-toolbar {
  border: 1px solid #d8dce5;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  padding: 5px 0;
  line-height: 0;
  background-color: rgba(0, 0, 0, 0.08);
}
#information .infoContent {
  height: 500px;
  border: 1px solid #d8dce5;
  border-top: 0;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  line-height: 1.6;
  font-size: 16px;
  padding: 5px 0;
}
#information .container {
  display: -webkit-flex;
  display: flex;
}
#information .preview {
  padding: 20px 40px 20px 0;
  position: relative;
}
#information .preview-content {
  position: absolute;
  width: 262.5px;
  height: 426.3px;
  overflow-y: auto;
  top: 143.9px;
  left: 32.9px;
  background-color: #eee;
  font-size: 12px;
  color: #666;
}
#information .preview-content i.fa {
  font-size: 15px;
  color: #409eff;
  width: 15px;
  margin-right: 2px;
}
#information .information-content {
  -webkit-flex: 1;
  flex: 1;
  margin: 10px 0 20px 0;
}
#information .information-des {
  height: 520px;
  overflow-y: auto;
  padding: 20px;
  border: solid 1px #e6e6e6;
  line-height: 22px;
  font-size: 14px;
  color: #666;
  word-break: break-all;
  opacity: 0.9;
}
#information .information-des img {
  max-width: 100%;
  height: auto;
}
#information .container2 {
  padding-top: 20px;
}
#information .container2-top {
  display: -webkit-flex;
  display: flex;
}
#information .picture-upload-wrapper {
  width: 420px;
  height: 255px;
}
#information .form-top {
  -webkit-flex: 1;
  flex: 1;
  padding-left: 20px;
}
#information .avatar-uploader .el-upload {
  border: 1px dashed #888;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
#information .avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
#information .avatar-uploader i.fa {
  font-size: 40px;
  color: #8c939d;
  width: 412px;
  height: 248px;
  line-height: 200px;
  text-align: center;
}
#information .avatar-uploader i.fa + span {
  color: #8c939d;
  position: absolute;
  display: inline-block;
  width: 300px;
  text-align: center;
  top: 148px;
  left: 50%;
  margin-left: -150px;
  font-size: 13px;
}
#information .avatar-uploader .avatar {
  width: 412px;
  height: 248px;
  display: block;
}
#information .avatar-uploader .hover-show {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  display: none;
  background-color: rgba(0, 0, 0, 0.4);
  color: #fff;
}
#information .avatar-uploader .hover-show i.fa,
#information .avatar-uploader .hover-show span {
  color: #fff !important;
}
#information .avatar-uploader.haveImg:hover .hover-show {
  display: block;
}
/*楼层分布的图片上传样式*/
#information .picture-uploader .el-upload {
  border: 1px dashed #888;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
#information .picture-uploader .el-upload:hover {
  border-color: #409eff;
}
#information .picture-uploader i.fa {
  font-size: 40px;
  color: #8c939d;
  width: 700px;
  min-height: 200px;
  line-height: 180px;
  text-align: center;
}
#information .picture-uploader i.fa + span {
  color: #8c939d;
  position: absolute;
  display: inline-block;
  width: 340px;
  text-align: center;
  top: 148px;
  left: 50%;
  margin-left: -170px;
  font-size: 13px;
}
#information .picture-uploader .picture {
  width: 700px;
  height: auto;
  display: block;
}
#information .picture-uploader .hover-show {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  display: none;
  background-color: rgba(0, 0, 0, 0.4);
  color: #fff;
}
#information .picture-uploader .hover-show i.fa,
#information .picture-uploader .hover-show span {
  color: #fff !important;
}
#information .picture-uploader.haveImg:hover .hover-show {
  display: block;
}
</style>
